module.exports = __webpack_public_path__ + "img/telegramDark.8ae72690.svg";